<template>
  <stage-card-info-list>
    <template #header>Relevance Ranking AI</template>
    <template #content>
      <!-- Votes required for training -->
      <stage-card-info-list-item
        v-if="showRelevantNotRelevantNeeded"
        class="required-votes"
      >
        Votes required for training

        <!-- Counts with icons -->
        <template #append>
          <div class="vote-counts">
            <div class="relevant-required-count">
              <v-icon
                color="success"
                size="14"
                class="material-icons-outlined"
              >
                thumb_up
              </v-icon>
              {{ requiredRelevantCount }}
            </div>
            <div class="not-relevant-required-count">
              <v-icon
                color="error"
                size="14"
                class="material-icons-outlined"
              >
                thumb_down
              </v-icon>
              {{ requiredNotRelevantCount }}
            </div>
          </div>
        </template>
      </stage-card-info-list-item>

      <!-- Training in progress -->
      <stage-card-info-list-item v-else-if="isTraining">
        <v-icon>sync</v-icon>
        Training in progress...
      </stage-card-info-list-item>

      <!-- Votes until the next training session -->
      <bubble-info-list-item
        v-else
        :bubble-text="votesUntilNextTraining"
      >
        Votes until next training session
      </bubble-info-list-item>
    </template>
  </stage-card-info-list>
</template>

<script>
import StageCardInfoList from '@/components/DashboardTab/StageCardInfoList';
import StageCardInfoListItem from '@/components/DashboardTab/StageCardInfoListItem';
import BubbleInfoListItem from '@/components/DashboardTab/BubbleInfoListItem';
import { Review } from '@/models';

export default {
  name: 'RelevanceRankingStatus',
  components: {
    StageCardInfoList,
    StageCardInfoListItem,
    BubbleInfoListItem,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    showRelevantNotRelevantNeeded() {
      return this.review.trainingStats.datasetInvalid();
    },
    isTraining() {
      return !!this.review.activeJob;
    },
    votesUntilNextTraining() {
      return this.trainingStats.votesUntilTriggerTrainingCount || 1;
    },
    requiredRelevantCount() {
      return (
        this.trainingStats.requiredRelevantVotesRemainingCount || 0
      );
    },
    requiredNotRelevantCount() {
      return (
        this.trainingStats.requiredNotRelevantVotesRemainingCount || 0
      );
    },
    trainingStats() {
      return this.review.trainingStats;
    },
  },
};
</script>

<style lang="scss" scoped>
.vote-counts {
  display: flex;
  gap: 12px;
}
</style>
